:host {
  height: auto;
}

.form-field-input {
  width: var(--form-field-label-width);
  margin-top: calc(var(--spacer) * 1.5);
}

.sub-module {
  margin-left: 26px;
}

.sub-module-section {
  gz-form-field {
    &::part(form-field-label) {
      min-width: 224px;
      max-width: 224px;
    }
  }
}

.form-section {
  margin-top: calc(var(--spacer) * 2);

  .flex-group {
    display: flex;
    align-items: flex-start;

    .module-icon {
      margin-top: 12px;
      width: 39px;
      color: var(--chart-302-icon-buttons-titles);
    }
  }

  .form-field-input {
    width: 400px;
  }
}
